import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const MobileMenu = () => {
    let trigger = $('.nav__menu-mobile-toggle');
    let menuOpen = false;

    trigger.click(() => {
        if (!menuOpen) {
            menuOpen = openMenu();
        } else {
            menuOpen = closeMenu();
        }
    });

    $('.menu-item').click(e => {
        if ($(window).innerWidth() < 1280 && $(e.target).hasClass('menu-item-has-children')) {
            findSubMenu($(e.target));
        }
    })
}

const openMenu = () => {
    $('.nav-lower').addClass('nav-lower--mobile-active');
    $('.nav__menu-toggle-bar').addClass('nav__menu-toggle-bar--active');
    $('body').addClass('mobile-menu-active');
    disableBodyScroll(document.querySelector('.menu'));
    let menus = document.querySelectorAll('.sub-menu-wrap');

    menus.forEach(menu => {
        disableBodyScroll(menu);
    })
    return true;
}

const closeMenu = () => {
    $('.nav-lower').removeClass('nav-lower--mobile-active');
    $('.nav__menu-toggle-bar').removeClass('nav__menu-toggle-bar--active');
    $('.sub-menu-active').css({
        'left': '100%'
    });
    $('.nav-lower').css({
        'left': '0%'
    })
    $('.sub-menu-active').removeClass('sub-menu-active');
    $('body').removeClass('mobile-menu-active');
    clearAllBodyScrollLocks();
    $('body').css({
        'overflow': 'visible'
    })
    return false;
}

const findSubMenu = (el) => {
    let subMenu = $(el).children('.sub-menu-wrap').children('.sub-menu');

    $(el).children('.sub-menu-wrap').addClass('sub-menu-active')
    $(el).children('.sub-menu-wrap').animate({
        'left': 0
    }, 200, 'linear', () => {
        $(el).children('.sub-menu-wrap').css({
            'overflow': 'scroll'
        })
    })

    if (!subMenu.hasClass('has-back')) {
        generateBackMarkup(subMenu);
    }


    if ($(el).parent().hasClass('menu')) {
        $('.nav-lower').animate({
            'left': "-100%"
        }, 200, 'linear')
        $('.nav-lower').css({
            'overflow': 'visible'
        })
    } else {
        $(el).parent().parent().css({
            'overflow': 'visible'
        })
        $(el).parent().parent().animate({
            'left': "-100%"
        }, 200, 'linear')
    }

    $(document).on('click', '.menu-item-back', (e) => {
        let target = $(e.target);
        if (!window.menuAnimating) {
            window.menuAnimating = true;

            if ($(target).parent().parent().parent().parent().hasClass('menu')) {
                // LAST BACKWARDS MOVEMENT
                $(target).parent().parent().animate({
                    'left': '100%'
                }, 200, 'linear', () => {
                    window.menuAnimating = false;
                });
                $('.nav-lower').animate({
                    'left': '0%'
                }, 200, 'linear', () => {
                    window.menuAnimating = false;
                    $(target).parent().parent().removeClass('sub-menu-active');
                });
            } else {
                // INTERNAL BACKWARDS MOVEMENT
                $(target).parent().parent().animate({
                    'left': '100%'
                }, 200, 'linear', () => {
                    window.menuAnimating = false;
                });
                $(target).parent().parent().parent().parent().parent().animate({
                    'left': '0%'
                }, 200, 'linear', () => {
                    window.menuAnimating = false;
                    $(target).parent().parent().removeClass('sub-menu-active');
                });
            }  
        }
    })
}

const generateBackMarkup = (el) => {
    let output =
    `
        <li class="menu-item menu-item-back">Back</li>
    `;

    $(el).prepend(output);
    $(el).addClass('has-back');
}

(function () {
    var _overlay = document.querySelector('.nav-lower');
    var _clientY = null; // remember Y position on touch start

    _overlay.addEventListener('touchstart', function (event) {
        if (event.targetTouches.length === 1) {
            // detect single touch
            _clientY = event.targetTouches[0].clientY;
        }
    }, false);

    _overlay.addEventListener('touchmove', function (event) {
        if (event.targetTouches.length === 1) {
            // detect single touch
            disableRubberBand(event);
        }
    }, false);

    function disableRubberBand(event) {
        var clientY = event.targetTouches[0].clientY - _clientY;

        if (_overlay.scrollTop === 0 && clientY > 0) {
            // element is at the top of its scroll
            event.preventDefault();
        }

        if (isOverlayTotallyScrolled() && clientY < 0) {
            //element is at the top of its scroll
            event.preventDefault();
        }
    }

    function isOverlayTotallyScrolled() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
        return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
    }
}())

export default MobileMenu;


// WEBPACK FOOTER //
// ./src/js/app/components/MobileMenu.js